module.exports = __webpack_public_path__ + "media/images/c-adminSidebarLink/users-a56394e0120b4431d82033099bfc335f.svg";